"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEAusrichtung = void 0;
var AEAusrichtung;
(function (AEAusrichtung) {
    AEAusrichtung["pendelnd"] = "pendelnd";
    AEAusrichtung["starr"] = "starr";
})(AEAusrichtung = exports.AEAusrichtung || (exports.AEAusrichtung = {}));
//# sourceMappingURL=AEAusrichtung.js.map